<template>
  <nav class="navbar fixed-top navbar-expand-lg navbar-dark navbar-custom">
  <div class="container-fluid">
    <a class="navbar-brand" href="#">
      <img src="@/assets/logo.png" style="width: 30px; heigth: 30px" />
      泰順物流代理系統</a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item">
           <router-link :to="'/home'" class="nav-link active">
                        <span>首頁</span>
            </router-link>
         </li>
         <li class="nav-item" v-if="!user">
           <router-link :to="'/login'" class="nav-link">
                        <span>登入</span>
            </router-link>
         </li>


        <li class="nav-item"  v-if="user">
          <router-link :to="'/expawb'" class="nav-link">
                        <span>出口提單</span>
            </router-link>
        </li>
        <li class="nav-item"  v-if="user">
          <router-link :to="'/impawb'" class="nav-link">
                        <span>進口提單</span>
            </router-link>
        </li>
        <li class="nav-item"  v-if="user">
          <router-link :to="'/areacodeaudio'" class="nav-link">
                        <span>分區播音設定</span>
            </router-link>
        </li>
        <li class="nav-item"  v-if="user">
          <router-link :to="'/statusclear'" class="nav-link">
                        <span>清關分貨作業</span>
            </router-link>
        </li>

        

        
          <li class="nav-item" v-if="user">
          <a class="nav-link" href="#">{{ user?.clientName }}你好!</a>
          
        </li>
         <li class="nav-item" v-if="user">
           
           <button type="button" class="btn btn-link"  @click="logout">登出</button>
         </li>

        
         
      </ul>
      
    </div>
  </div>
</nav>
</template>
<style scoped>
.navbar-text {
  color: white;
}
</style>
<script>
export default {
 
  data() {
    return {
      options: null,
    };
  },
  computed: {
   
    user() {
     return this.$store.state.user;
    },
     clientId() {
     return this.$store.state.user?.clientId;
    },
   
  },
   
  methods: {
          
         logout() {
          // remove user from local storage to log user out
          sessionStorage.removeItem('user');
            this.$store.commit("setClientId", null);
            this.$store.commit("Set_User", null);
            this.$router.replace("/"); 
        }
    }
};
</script>
